/**
 * Downloads a PDF file from a given URL with proper headers
 * @param url - The URL to download the PDF from
 * @param filename - The desired filename for the downloaded file
 * @throws Error if the download fails
 */
export async function downloadPdf(
  url: string,
  filename: string,
): Promise<void> {
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      Accept: 'application/pdf',
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // Get the blob data
  const blob = await response.blob();

  // Create download link
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = filename;

  // Trigger download
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up
  window.URL.revokeObjectURL(downloadUrl);
}
